export default {
      id: "group-3-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "sprite.svg#group-3",
      toString: function () {
        return this.url;
      }
    }